import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { settingsAPI } from '../api';
import { useSettings } from '../contexts/SettingsContext';

const About = () => {
  const { settings } = useSettings();
  const [aboutContent, setAboutContent] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadAboutContent();
  }, []);

  // Update title on mount
  useEffect(() => {
    document.title = `Hakkımızda - ${settings.site_name || 'Cinefora'}`;
  }, [settings.site_name]);

  const loadAboutContent = async () => {
    try {
      const response = await settingsAPI.get();
      setAboutContent(response.data.about_content || 'İçerik henüz eklenmemiş.');
    } catch (error) {
      console.error('Error loading about content:', error);
      setAboutContent('Cinefora, Türkiye\'nin önde gelen sinema zincirleri arasında yer almaktadır.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0a0a0a]">
      <Helmet>
        <title>Hakkımızda - {settings.site_name || 'Cinefora'}</title>
        <meta name="description" content="Cinefora hakkında bilgi edinin. Sinema vizyonumuz, misyonumuz ve hikayemiz." />
        <meta name="keywords" content="hakkımızda, cinefora, sinema, about" />
      </Helmet>
      <Header />
      <div className="container mx-auto px-6 py-32">
        <h1 className="text-4xl font-bold text-white mb-8">Hakkımızda</h1>
        {loading ? (
          <p className="text-gray-300">Yükleniyor...</p>
        ) : (
          <div className="text-gray-300 space-y-4 max-w-3xl whitespace-pre-line">
            {aboutContent}
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
};

export default About;
